const INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASE_FIELD_NAMES = {
  FREE_FROM: 'freeFrom',
  LOCATION_TYPE: 'locationType',
  PHYSICAL_PROPERTY: 'physicalProperty',
  OTHER: 'other',
}

export default INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASE_FIELD_NAMES
